import React from "react";
import { Trans } from "@lingui/macro";
import {
  Button,
  ButtonVariant,
  IconName
} from "@silversea-ssc/ui-components-react";
import { PageCtaFragment } from "types/graphql-types";

export interface PageBuilderPageCTAButtonProps extends PageCtaFragment {
  defaultVariant?: ButtonVariant;
  iconName?: IconName;
}

const DefaultCTALabel = <Trans id="cta-discover-more">Discover more</Trans>;

const PageBuilderPageCTAButton: React.FC<PageBuilderPageCTAButtonProps> = ({
  defaultVariant = "primary",
  iconName,
  ...props
}) => {
  return (
    <Button
      renderAs="a"
      href={props.page?.fullPath}
      variant={(props.variant || defaultVariant) as ButtonVariant}
      data-content-piece="page_cta_button"
      iconName={iconName}
    >
      {props.label?.localized || DefaultCTALabel}
    </Button>
  );
};

export default PageBuilderPageCTAButton;
